(() => {
  const reviewSelector = [
    '.jdgm-rev-widg',
    '[data-widget-name="review_widget"]',
    '[data-judge-me-reviews-widget]',
    '.jdgm-widget.jdgm-review-widget',
  ].join(',');
  const homepageImageSelector = "[class*='image-block--image_product_placeholder'] .image-block__image";
  const ritualLinkSelector = '[data-lurxecare-return-story] a';
  const relevantSelector = `${reviewSelector},${homepageImageSelector},${ritualLinkSelector}`;

  const containsMatch = (scope, selector) =>
    (scope instanceof Element && scope.matches(selector)) || Boolean(scope.querySelector?.(selector));

  const replaceHomepageProductImage = () => {
    const imageUrl = document.body.dataset.lurxecareOilCollectionImage;
    if (!imageUrl) return;

    const section =
      document.querySelector("[id$='__individual_product_card_theme_install']") ??
      document.querySelector('.color-custom-individual_product_card_theme_install')?.closest('.shopify-section');
    const image = section?.querySelector("[class*='image-block--image_product_placeholder'] .image-block__image");

    if (!image || image.dataset.lurxecareV32 === 'true') return;

    const picture = image.closest('picture');
    picture?.querySelectorAll('source').forEach((source) => {
      source.removeAttribute('srcset');
      source.removeAttribute('sizes');
    });

    image.src = imageUrl;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.alt = 'Aromatic body-oil collection displayed in a warm luxury studio';
    image.loading = 'lazy';
    image.decoding = 'async';
    image.dataset.lurxecareV32 = 'true';
  };

  const correctRitualLink = () => {
    const link = document.querySelector('[data-lurxecare-return-story] a');
    const collectionsUrl = document.body.dataset.lurxecareCollectionsUrl;
    if (link && collectionsUrl) link.href = collectionsUrl;
  };

  const createReviewSky = () => {
    const sky = document.createElement('span');
    sky.className = 'lurxecare-review-sky';
    sky.setAttribute('aria-hidden', 'true');

    for (let index = 0; index < 9; index += 1) {
      const star = document.createElement('span');
      star.className = 'lurxecare-review-star';
      star.style.setProperty('--star-index', index);
      sky.appendChild(star);
    }

    return sky;
  };

  const enhanceJudgeMeReviews = (scope = document) => {
    const widgets = [];
    if (scope instanceof Element && scope.matches(reviewSelector)) widgets.push(scope);
    scope.querySelectorAll(reviewSelector).forEach((widget) => widgets.push(widget));

    widgets.forEach((widget) => {
      if (widget.dataset.lurxecareStars === 'true') return;

      widget.classList.add('lurxecare-judge-stars');
      widget.prepend(createReviewSky());
      widget.dataset.lurxecareStars = 'true';
    });
  };

  const initialize = (scope = document) => {
    if (scope === document || containsMatch(scope, homepageImageSelector)) replaceHomepageProductImage();
    if (scope === document || containsMatch(scope, ritualLinkSelector)) correctRitualLink();
    enhanceJudgeMeReviews(scope);
  };

  let animationFrame;
  const pendingScopes = new Set();
  const queueInitialize = (scope) => {
    if (!(scope instanceof Element || scope instanceof Document || scope instanceof DocumentFragment)) return;
    pendingScopes.add(scope);
    if (animationFrame) return;

    animationFrame = window.requestAnimationFrame(() => {
      animationFrame = null;
      const scopes = [...pendingScopes];
      pendingScopes.clear();
      scopes.forEach((pendingScope) => {
        if (pendingScope.isConnected !== false) initialize(pendingScope);
      });
    });
  };

  const watchForAppWidgets = () => {
    if (!document.body || document.body.dataset.lurxecareWidgetObserver === 'true') return;

    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        const reviewWidget = record.target instanceof Element ? record.target.closest(reviewSelector) : null;
        if (reviewWidget && reviewWidget.dataset.lurxecareStars !== 'true') queueInitialize(reviewWidget);
        record.addedNodes.forEach((node) => {
          if (!(node instanceof Element || node instanceof DocumentFragment)) return;
          if (containsMatch(node, relevantSelector)) queueInitialize(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.body.dataset.lurxecareWidgetObserver = 'true';
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initialize();
        watchForAppWidgets();
      },
      { once: true }
    );
  } else {
    initialize();
    watchForAppWidgets();
  }

  document.addEventListener('shopify:section:load', (event) => queueInitialize(event.target));
})();
